// ============================================================================
// L'ANCIENNETÉ D'UN CLIENT — l'année depuis laquelle il est client, telle que la fiche l'affiche sous son nom.
// UTILITÉ : la caisse et le back-office écrivent « client depuis … » ; la règle qui choisit l'année vit ici,
// une fois, pour que les deux en-têtes ne disent pas deux anciennetés pour la même personne.
// ============================================================================

/**
 * L'année depuis laquelle on est client — celle du PREMIER ACHAT, sinon celle de la fiche, sinon `null`.
 *
 * ⚠️ L'ACHAT D'ABORD : une fiche reprise ou recréée peut être plus jeune que le premier achat de la
 *    personne, et c'est l'achat qui dit l'ancienneté.
 * ⚠️ `null` QUAND RIEN NE LA DIT : une date de fiche nulle donnerait 1970, une ancienneté inventée.
 * `firstVisitFiscal` = l'horodatage fiscal du premier achat (`AAAAMMJJ…`) ; `createdAtMs` = la fiche.
 */
export function clientSinceYear(firstVisitFiscal: string | null | undefined, createdAtMs: number | null | undefined): number | null {
  if (firstVisitFiscal && /^\d{4}/.test(firstVisitFiscal)) return Number(firstVisitFiscal.slice(0, 4));
  return createdAtMs && createdAtMs > 0 ? new Date(createdAtMs).getFullYear() : null;
}
